module.exports = __webpack_public_path__ + "img/InvoiceMessage.a9318cf9.png";